import { useForm } from "react-hook-form"
import "./contact.css"
import { ContactFormGroup } from "./contactFormGroup"
import { useEffect } from "react"

export default function Contact(props) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitSuccessful },
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      phone: "",
      comments: "",
    },
  })

  useEffect(() => {
    if (isSubmitSuccessful) {
      reset()
    }
  }, [isSubmitSuccessful, reset])

  async function onSubmit(data) {
    console.log(data)
    try {
      const dataFetch = await fetch("https://clubvollocity.com//api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          content: data,
        }),
      })

      if (!dataFetch.ok) {
        throw "Error Processing Request"
      }

      const res = await dataFetch.json()
      console.log(res)
    } catch (error) {
      console.log(error)
    }
  }

  const size = props.size === "sm" || props.size === "xsm"

  return (
  <div className="ContactFormat">
    <div className={props.size === "sm" ? "meeting sm" : "meeting"} id="Meeting">
      <h2>Practice Dates</h2>
      <span className="Date"> December 3, 5, 10, 12, 17, 19 </span>
      <span className="Date"> January 7, 9, 14, 16, 21, 23, 28, 30 </span>
      <span className="Date"> February 4, 6, 11, 13, 18, 20, 25, 27 </span>
      <span className="Date"> March 4, 6, 11, 13, 18 </span>
      <span className="Date"> Tournament Dates will be added and communicated via our Facebook page and Web
      Site as they are decided.</span>
    </div>
    <div className={ size ? "contact sm" : "contact" } id="Contact">
      <div className="title-logo">
        <h2>Contact Us</h2>
      </div>
      <div className={ size ? "contact-card sm" : "contact-card" }>
        <p className="call-now">
          <br />
          To contact us with any problems or questions
          <br /> complete and submit the form below
        </p>
        <form onSubmit={ handleSubmit(onSubmit) } className="form">
          <ContactFormGroup errorMessage={ errors?.name?.message }>
            <label className="contact-label" htmlFor="name">
              Name:{ " " }
            </label>
            <input
              id="name"
              { ...register("name", {
                required: { value: true, message: "Name Required" },
                validate: (value) => {
                  if (value.match(/\d/)) return "Cannot include numbers"
                },
              }) }
            />
          </ContactFormGroup>
          <ContactFormGroup errorMessage={ errors?.email?.message }>
            <label className="contact-label" htmlFor="email">
              Email:{ " " }
            </label>
            <input
              id="email"
              { ...register("email", {
                required: { value: true, message: "Email Required" },
                validate: (value) => {
                  if (
                    !value.match(
                      /^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/
                    )
                  ) {
                    return "Invalid Email"
                  }
                },
              }) }
            />
          </ContactFormGroup>
          <ContactFormGroup errorMessage={ errors?.phone?.message }>
            <label className="contact-label" htmlFor="number">
              Phone:{ " " }
            </label>
            <input
              id="number"
              { ...register("phone", {
                required: { value: true, message: "Phone Number Required" },
                minLength: {
                  value: 10,
                  message: "Must have at least 10 characters",
                },
                maxLength: {
                  value: 13,
                  message: "Cannot have more than 11 characters",
                },
                validate: {
                  hasLetters: (value) => {
                    if (value.match(/[a-z]/) || value.match(/[A-Z]/) || value.match(/[-]/)) {
                      return "Must only include number 0-9"
                    }
                  },
                },
              }) }
            />
          </ContactFormGroup>
          <ContactFormGroup errorMessage={ errors?.comments?.message }>
            <label className="contact-label" htmlFor="comments">
              Comments:{ " " }
            </label>
            <input
              id="comments"
              { ...register("comments", {
                required: { value: false },
                maxLength: {
                  value: 250,
                  message: "Cannot exceed 250 characters",
                },
              }) }
            />
          </ContactFormGroup>
          <input type="submit" className="submit" />
        </form>
      </div>
    </div>
    </div>
  )
}
